import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { eventOn, eventOff, triggerEvent, sendRequest } from '../helpers/global';

import SidebarView from './sidebar/SidebarView.js';
import DropdownMenu from './common/DropdownMenu.js';

import '../sass/components/HeaderView.scss';

const mapStoreToProps = (store) => {
  return {
    user: store.data.user,
    isMobile: store.setup.isMobile,
  }
};

class HeaderView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      historyDepth: 1,
      title: null,
      currentMonth: moment().set('date', 1),
      prevMonth: moment().subtract(1, 'month').set('date', 1),
      prevMonthTotal: 0,
      currentMonthTotal: 0,
    };
  }

  componentDidMount = () => {
    this.updateTotals();
    this.props.history.listen((loc, type) => {
      if (type === 'PUSH') {
        this.setState({historyDepth: this.state.historyDepth + 1, title: null});
      } else if (type === 'POP') {
        this.setState({historyDepth: this.state.historyDepth - 1, title: null});
      } else {
        this.setState({title: null});
      }
    });
    eventOn('setHeaderTitle', this.setHeaderTitle);
    eventOn('updateTotals', this.updateTotals);
  }

  componentWillUnmount = () => {
    eventOff('setHeaderTitle', this.setHeaderTitle);
    eventOff('updateTotals', this.updateTotals);
  }

  setHeaderTitle = (e) => {
    const { title } = e.detail[0];
    this.setState({title});
  }

  getPageTilte = () => {
    const isMobile = this.props.isMobile;
    return isMobile ? '' : 'Provision заказы';
  }

  onLogout = () => {
    triggerEvent('showConfirmation', [{
      title: 'Выход из панели управления',
      confirmText: 'Выйти',
      cancelText: 'Отмена',
      callback: confirm => {
        if (confirm) {
          this.props.onLogout();
        }
      }
    }]);
  }

  updateTotals = () => {
    this.requestTotal('current');
    this.requestTotal('prev');
  }

  requestTotal = (type) => {
    let from = this.state.currentMonth;
    if (type === 'prev') {
      from = this.state.prevMonth;
    }
    sendRequest({
      method: 'orders/total_amount',
      type: 'GET',
      data: {
        from: from.format('YYYY-MM-DD'),
        to: moment(from).endOf('month').format('YYYY-MM-DD'),
      },
      noLoad: true,
      success: (data) => {
        this.setState({
          [type === 'prev' ? 'prevMonthTotal' : 'currentMonthTotal']: data,
        });
      },
      error: (data) => {
      }
    });
  }

  render = () => {
    const user = this.props.user;
    if (!user) {
      return null;
    }
    return (
      <div className='headerView'>
        <span className='menuButton' onClick={() => this.setState({menuOpen: !this.state.menuOpen})}>
          <span className='material-icons'>menu</span>
        </span>
        <div className='headerLogo'/>
        <div className='pageInfo'>
          <div className='pageTitle'>{this.getPageTilte()}</div>
        </div>
        <div className='prevMonth'>
          <div className='monthName'>{this.state.prevMonth.format('MMMM')}:</div>
          <div className='monthTotal'>{this.state.prevMonthTotal} р</div>
        </div>
        <div className='currentMonth'>
          <div className='monthName'>{this.state.currentMonth.format('MMMM')}:</div>
          <div className='monthTotal'>{this.state.currentMonthTotal} р</div>
        </div>
        {/*this.state.historyDepth > 1 ?
          <span className='backLink' onClick={() => this.props.history.goBack()}>
            <span className='material-icons'>keyboard_backspace</span>
          </span>
        : null*/}
        <div className='userButton'>
          <span>{(user.name || user.email).substr(0, 1)}</span>
          <DropdownMenu
            anchorRight
            options={[
              {
                title: 'Настройки',
                onClick: () => this.props.history.push('/settings'),
              },
              {
                title: 'Выйти',
                onClick: () => this.onLogout(),
              },
            ]}
          />
        </div>
        <SidebarView
          open={this.state.menuOpen}
          onClose={() => this.setState({menuOpen: false})}
          onLogout={this.onLogout}
        />
      </div>
    )
  }

}

export default connect(mapStoreToProps)(withRouter(HeaderView));
